export default "__VITE_ASSET__ChPHA0w4__"